import React from "react";

import { AncillaryContentSubtype } from "../../../common/types/AncillaryContentType";
import { AssetsLookupDataProviders } from "../../common/AssetsLookupDataProvider";
import { ManageAncillaryProvider } from "../context/ManageAncillaryProvider";
import { AncillaryListing } from "./AncillaryListing";

interface AncillaryDashboardProps {
    contentType: AncillaryContentSubtype;
}

export const AncillaryDashboard: React.FC<AncillaryDashboardProps> = (props: AncillaryDashboardProps) => {
    return (
        <>
            <ManageAncillaryProvider ancillaryContentType={props.contentType}>
                <AssetsLookupDataProviders>
                    <AncillaryListing />
                </AssetsLookupDataProviders>
            </ManageAncillaryProvider>
        </>
    );
};
